import { render, staticRenderFns } from "./DialogItemHead.vue?vue&type=template&id=918ef598&"
import script from "./DialogItemHead.vue?vue&type=script&lang=js&"
export * from "./DialogItemHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports